<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-note"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $tc('translation', 99) }}
        </div>
      </template>

      <v-row class="mx-0">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @blur="getDataFromApi"
          @keydown.enter="getDataFromApi"
        />
      </v-row>
      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:item.translations="{ item }">
          {{ Object.keys(item.translations).length }}
        </template>
        <template v-slot:item.created_at="{item}">
          {{ convertUTCToLocal(item.created_at) }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              medium
              class="mr-5"

              color="green"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $tc('translation') }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                sm="12"
              >
                <v-text-field
                  dense
                  :label="$t('original_message')"
                  :value="editedItem.original_message"
                  disabled
                />
              </v-col>
              <v-col
                sm="12"
              >
                <v-select
                  :value="editedItem.locale"
                  :label="$t('language')"
                  dense
                  :items="languages"
                  @change="onLocaleChange"
                />
              </v-col>
              <v-col
                sm="12"
              >
                <v-text-field
                  v-model="editedItem.translated_message"
                  dense
                  :label="$t('translated_message')"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="doSave"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'
  export default {
    mixins: [List],
    data () {
      return {
        dialog_send_mail: false,
        endpoint: 'translation',
        name: 'translation',
        headers: [
          {
            sortable: false,
            text: this.$t('category'),
            value: 'category',
            align: 'center',
          },
          {
            sortable: false,
            text: this.$t('original_message'),
            value: 'original_message',
            align: 'center',
          },
          {
            sortable: false,
            text: this.$tc('translation', 99),
            value: 'translations',
          },
          {
            sortable: false,
            text: this.$t('created'),
            align: 'right',
            value: 'created_at',
            type: 'date',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },
        ],
        editedItem: {
          original_message: '',
          translations: {},
          locale: '',
          translated_message: '',
        },
        defaultItem: {
          original_message: '',
          translations: {},
          locale: '',
          translated_message: '',

        },
        languages: [],
      }
    },
    mounted: function () {
      this.$get(`/${this.endpoint}/languages`)
        .then(response => {
          this.languages = response.data
        })
    },
    methods: {
      editItem (item) {
        if (!this.canUpdate()) { return }

        this.editedIndex = this.$_.findIndex(this.items, c => c.id === item.id)
        if (this.editedIndex !== -1) {
          const locale = this.$_.first(Object.keys(item.translations)) || 'da'
          this.editedItem = Object.assign({ locale, translated_message: item.translations[locale] }, item)
        }
        this.dialog = true
      },

      onLocaleChange (val) {
        this.setTranslation()
        this.editedItem.locale = val
        this.editedItem.translated_message = this.editedItem.translations[val]
      },
      setTranslation () {
        const oldLocale = this.editedItem.locale
        const translations = { ...this.editedItem.translations }
        translations[oldLocale] = this.editedItem.translated_message
        this.editedItem.translations = translations
      },
      doSave: function () {
        this.setTranslation()
        const { translated_message, locale, ...editedItem } = this.editedItem
        this.editedItem = editedItem
        this.save()
      },
    },
  }
</script>
